import api from "../_api";

const actions = {
    getGrades: ({ commit, dispatch }) => {
        return new Promise((resolve, reject) => {
            commit("TEAM_NOMINATION_LOADING");

            api.grades()
                .then(grades => {
                    commit("TEAM_NOMINATION_GRADES", grades.data);
                    resolve(grades.data);
                })
                .catch(err => {
                    let errors = { error: "Techinal Issue, Please try again later" };
                    let errorMsg = errors.error;
                    if (err.response.status != 500) {
                        errors = err.response.data.errors ? err.response.data.errors.error : err.response.data.error;
                    }

                    commit("TEAM_NOMINATION_ERROR", errors);
                    reject(errorMsg);
                });
        });
    },
    getSeasons: ({ commit, dispatch }) => {
        return new Promise((resolve, reject) => {
            commit("TEAM_NOMINATION_LOADING");

            api.seasons()
                .then(seasons => {
                    commit("TEAM_NOMINATION_SEASONS", seasons.data);
                    resolve(seasons.data);
                })
                .catch(err => {
                    let errors = { error: "Techinal Issue, Please try again later" };
                    let errorMsg = errors.error;
                    if (err.response.status != 500) {
                        errors = err.response.data.errors ? err.response.data.errors.error : err.response.data.error;
                    }

                    commit("TEAM_NOMINATION_ERROR", errors);
                    reject(errorMsg);
                });
        });
    },
    getDivisionGroups: ({ commit, dispatch }, payload) => {
        return new Promise((resolve, reject) => {
            commit("TEAM_NOMINATION_LOADING");

            api.divisiongroups(payload.division_type)
                .then(divisiongroups => {
                    commit("TEAM_NOMINATION_DIVISION_GROUPS", divisiongroups.data);
                    resolve(divisiongroups.data);
                })
                .catch(err => {
                    let errors = { error: "Techinal Issue, Please try again later" };
                    let errorMsg = errors.error;
                    if (err.response.status != 500) {
                        errors = err.response.data.errors ? err.response.data.errors.error : err.response.data.error;
                    }

                    commit("TEAM_NOMINATION_ERROR", errors);
                    reject(errorMsg);
                });
        });
    },
    getDivisions: ({ commit, dispatch }, payload) => {
        return new Promise((resolve, reject) => {
            commit("TEAM_NOMINATION_LOADING");

            api.divisions(payload.division_group)
                .then(divisions => {
                    commit("TEAM_NOMINATION_DIVISIONS", divisions.data);
                    resolve(divisions.data);
                })
                .catch(err => {
                    let errors = { error: "Techinal Issue, Please try again later" };
                    let errorMsg = errors.error;
                    if (err.response.status != 500) {
                        errors = err.response.data.errors ? err.response.data.errors.error : err.response.data.error;
                    }

                    commit("TEAM_NOMINATION_ERROR", errors);
                    reject(errorMsg);
                });
        });
    },
    getPreferredDivisions: ({ commit, dispatch }, payload) => {
        commit("TEAM_NOMINATION_NOWAITLIST_DIVISIONS");
        // return new Promise((resolve, reject) => {
        //     commit("TEAM_NOMINATION_LOADING");

        //     api.preferreddivisions(payload.division)
        //         .then(preferreddivisions => {
        //             commit("TEAM_NOMINATION_PREFERRED_DIVISIONS", preferreddivisions.data);
        //             resolve(preferreddivisions.data);
        //         })
        //         .catch(err => {
        //             let errors = { error: "Techinal Issue, Please try again later" };
        //             let errorMsg = errors.error;
        //             if (err.response.status != 500) {
        //                 errors = err.response.data.errors ? err.response.data.errors.error : err.response.data.error;
        //             }

        //             commit("TEAM_NOMINATION_ERROR", errors);
        //             reject(errorMsg);
        //         });
        // });
    },
    teamnominationRequest: ({ commit, dispatch }, payload) => {
        return new Promise((resolve, reject) => {
            commit("TEAM_NOMINATION_LOADING");

            api.teamnomination(payload.division)
                .then(resp => {
                    commit("TEAM_NOMINATION_SUCCESS", resp.data);
                    resolve(resp.data);
                })
                .catch(err => {
                    let errors = { error: "Techinal Issue, Please try again later" };
                    let errorMsg = errors.error;
                    if (err.response.status != 500) {
                        errors = err.response.data.errors ? err.response.data.errors.error : err.response.data.error;

                        if (err.response.status == 422) {
                            commit("TEAM_NOMINATION_DIVISIONS", err.response.data);
                            resolve(err.response.data);
                        }
                    }

                    if (err.response.status != 422) {
                        commit("TEAM_NOMINATION_ERROR", errors);
                        reject(errorMsg);
                    }
                });
        });
    },
    checkPlayer: ({ commit, dispatch }, payload) => {
        return new Promise((resolve, reject) => {
            commit("TEAM_NOMINATION_LOADING");

            api.checkplayer(payload.player, payload.division, payload.fromteamentry)
                .then(resp => {
                    // commit('TEAM_NOMINATION_SUCCESS', resp.data);
                    resolve(resp.data);
                })
                .catch(err => {
                    let errors = { error: "Techinal Issue, Please try again later" };
                    let errorMsg = errors.error;
                    if (err.response.status != 500) {
                        errors = err.response.data.errors ? err.response.data.errors.error : err.response.data.error;
                        errorMsg = errors;
                    }

                    commit("TEAM_NOMINATION_ERROR", errors);
                    reject(errorMsg);
                });
        });
    },
    payTeamNomination: ({ commit, dispatch, state }, payload) => {
        let data = {
            manager: payload.manager,
            coach: payload.coach,
            team: payload.team,
            note: payload.note,
            teamCopy: payload.teamCopy,
            players: payload.players,
            donationCart: payload.donationCart,
            teamnominationCart: state.teamnominationCart,

            // cardNumber: payload.cardNumber,
            // cardName: payload.cardHolder,
            // cardExpiry: payload.cardExpiry,
            // cardCVC: payload.cardCVC,
            cardData: payload.cardPayload,
        };

        return new Promise((resolve, reject) => {
            commit("PAYMENT_LOADING");

            api.payteamnom(data)
                .then(resp => {
                    commit("PAYMENT_SUCCESS", resp.data);
                    dispatch("user/userRequest", null, { root: true });
                    resolve(resp.data.data.o_id);
                })
                .catch(err => {
                    let errors = err.response.data;

                    commit("PAYMENT_ERROR", errors);
                    reject(err.response);
                });
        });
    },
    clearPaymentErrors: ({ commit }) => {
        commit("CLEAR_PAYMENT_ERRORS");
    },
};

export default actions;
